import React from 'react'
import CloseIcon from '@material-ui/icons/Close'
import {
    CircularProgress,
    Container,
    DialogTitle,
    IconButton,
    makeStyles,
    Paper
} from '@material-ui/core'
import { TomImageItem } from './tom-image-item'
import { Button } from '../../root/components/common'
import { useNotProcessed } from '../hooks/useNotProcessed'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(() => ({
    header: {
        padding: '0 16px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    content: {
        padding: '0 16px'
    },
    paper: {
        marginBottom: 16
    },
    btn: {
        marginBottom: 48,
        marginTop: 48
    },
    loaderWrapper: {
        width: '100%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}))

export const TomImageProcess = ({ onClose }) => {
    const cls = useStyles()
    const { locale } = useSelector(store => store.main)

    const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage } =
        useNotProcessed()

    if (isLoading) {
        return (
            <div className={cls.loaderWrapper}>
                <CircularProgress />
            </div>
        )
    }

    return (
        <div>
            <DialogTitle>
                <div className={cls.header}>
                    <div />
                    <IconButton aria-label="close" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogTitle>
            <div className={cls.content}>
                <Container maxWidth="md">
                    {data.pages.map(page => (
                        <React.Fragment key={page?.nextSkip}>
                            {page.data.map(i => (
                                <Paper
                                    key={i.id}
                                    className={cls.paper}
                                    elevation={2}>
                                    <TomImageItem
                                        queryKey="notProcessedPictures"
                                        item={i}
                                        notProcessedStatuses={[
                                            'not_processed',
                                            'ai_processed'
                                        ]}
                                    />
                                </Paper>
                            ))}
                        </React.Fragment>
                    ))}
                    {hasNextPage && (
                        <Button
                            onClick={fetchNextPage}
                            disabled={isFetchingNextPage}
                            className={cls.btn}
                            fullWidth>
                            {isFetchingNextPage ? (
                                <CircularProgress color="inherit" size={24} />
                            ) : (
                                locale.tom.loadMore
                            )}
                        </Button>
                    )}
                </Container>
            </div>
        </div>
    )
}
